export default {
    RATE_LIMIT_EXCEEDED: 'Rate limit exceeded',
    NOT_VALID_CAPTCHA: 'Not valid captcha',
    REQUEST_VALIDATION_ERRORS: 'Request validation errors',
    REQUEST_API_ERROR: 'Oops... Something went terribly wrong.',
    NOT_AUTH: 'Not authenticated',
};
